'use strict';
import $ from 'jquery';

export default class Footer {
	constructor() {
		if($('footer').length > 0){
			$('.footer-expander .plus').on('click', function(){
				$('footer').toggleClass('expanded');
			})
		}
	}
}
